(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('AppCycleHelper', AppCycleHelper)

    /** @ngInject */
    function AppCycleHelper($state, $rootScope, ValidationMessageHelper, AuthenticationService, UtilHelper, AUTH_EVENTS, CONFIGURATION) {
        const AppCycleHelper = {
            handleOnRun,
            handleLocationChangeStart,
            handleStateChangeStart,
            handleStateChangeSuccess,
            handleStateChangeError,
            handleViewContentLoaded
        };

        return AppCycleHelper;

        function handleLocationChangeStart(event) {
            if ($rootScope.isSweetAlertModalOpen)
                event.preventDefault();
        }

        function handleStateChangeStart(transition) {
            $rootScope.alignLayoutCenter = false;

            const nextUrl = transition.to().url;

            if (transition.to().name.indexOf('app-auth') >= 0)
                return transition;

            if (nextUrl.indexOf('not-authorized') >= 0 && AuthenticationService.isLogged())
                return transition;

            if (!AuthenticationService.isLogged()) {
                AuthenticationService.logout();
                return false;
            }

            if (!AuthenticationService.canAccess(transition.to()))
                return transition.router.stateService.transitionTo('app.not-authorized');

            if (UtilHelper.isScreenSmaller(991) && $('body').hasClass('menu-fixed'))
                $rootScope.menuOpen = false;

            AuthenticationService.configureUserPermissions(transition.to());

            return transition;
        }

        function handleStateChangeSuccess() {
            $('.modal-backdrop').remove();

            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }

        function handleViewContentLoaded() {

        }

        function handleOnRun() {
            //Comment this to exit errors related to transition and/or transition related services like User or Menu
            // $state.defaultErrorHandler(angular.noop);

            $rootScope.isSweetAlertModalOpen = false;
            $rootScope.removeMessage = UtilHelper.removeErrorMessageForm;

            $rootScope.isMobile = UtilHelper.isScreenSmaller(991);

            $rootScope.toolName = CONFIGURATION.TOOL_NAME;
            $rootScope.companyName = CONFIGURATION.COMPANY_NAME;
            $rootScope.currentYear = moment().format('YYYY');
            $rootScope.ValidationMessage = ValidationMessageHelper.getMessage;

            $rootScope.$on(AUTH_EVENTS.NOT_AUTHENTICATED, AuthenticationService.logout);
        }

        function handleStateChangeError(error) {
            if (error && error.redirTo)
                $state.go(error.redirTo);
        }
    }
}());